// Auto-generated by @adva/tokens. Do not edit.
export const colorAccent = "var(--color-accent)";
export const colorAccentHi = "var(--color-accent-hi)";
export const colorAccentOnDark = "var(--color-accent-on-dark)";
export const colorAccentOnDarkHi = "var(--color-accent-on-dark-hi)";
export const colorSuccess = "var(--color-success)";
export const colorWarning = "var(--color-warning)";
export const colorDanger = "var(--color-danger)";
export const colorBrandOnDark = "var(--color-brand-on-dark)";
export const colorBrandOnLight = "var(--color-brand-on-light)";
export const colorBrandBgDark = "var(--color-brand-bg-dark)";
export const colorBrandBgLight = "var(--color-brand-bg-light)";
export const colorChartS1 = "var(--color-chart-s1)";
export const colorChartS2 = "var(--color-chart-s2)";
export const colorChartS3 = "var(--color-chart-s3)";
export const colorChartS4 = "var(--color-chart-s4)";
export const colorChartS5 = "var(--color-chart-s5)";
export const colorChartS6 = "var(--color-chart-s6)";
export const colorChartS7 = "var(--color-chart-s7)";
export const colorChartS8 = "var(--color-chart-s8)";
export const colorChartRamp1 = "var(--color-chart-ramp-1)";
export const colorChartRamp2 = "var(--color-chart-ramp-2)";
export const colorChartRamp3 = "var(--color-chart-ramp-3)";
export const colorChartRamp4 = "var(--color-chart-ramp-4)";
export const colorChartRamp5 = "var(--color-chart-ramp-5)";
export const colorBg = "var(--color-bg)";
export const colorSurface = "var(--color-surface)";
export const colorElevated = "var(--color-elevated)";
export const colorBorder = "var(--color-border)";
export const colorSidebarBg = "var(--color-sidebar-bg)";
export const colorTextHi = "var(--color-text-hi)";
export const colorTextMd = "var(--color-text-md)";
export const colorTextLo = "var(--color-text-lo)";
export const fontFamilyDisplay = "var(--font-family-display)";
export const fontFamilyBody = "var(--font-family-body)";
export const fontFamilyMono = "var(--font-family-mono)";
export const fontWeightLight = "var(--font-weight-light)";
export const fontWeightRegular = "var(--font-weight-regular)";
export const fontWeightMedium = "var(--font-weight-medium)";
export const fontWeightSemibold = "var(--font-weight-semibold)";
export const fontSizeDisplay = "var(--font-size-display)";
export const fontSizeTitle = "var(--font-size-title)";
export const fontSizeHeading = "var(--font-size-heading)";
export const fontSizeBody = "var(--font-size-body)";
export const fontSizeLabel = "var(--font-size-label)";
export const fontSizeData = "var(--font-size-data)";
export const lineHeightDisplay = "var(--line-height-display)";
export const lineHeightTitle = "var(--line-height-title)";
export const lineHeightHeading = "var(--line-height-heading)";
export const lineHeightBody = "var(--line-height-body)";
export const lineHeightLabel = "var(--line-height-label)";
export const lineHeightData = "var(--line-height-data)";
export const letterSpacingDisplay = "var(--letter-spacing-display)";
export const letterSpacingLabel = "var(--letter-spacing-label)";
export const letterSpacingWordmark = "var(--letter-spacing-wordmark)";
export const spacing1 = "var(--spacing-1)";
export const spacing2 = "var(--spacing-2)";
export const spacing3 = "var(--spacing-3)";
export const spacing4 = "var(--spacing-4)";
export const spacing5 = "var(--spacing-5)";
export const spacing6 = "var(--spacing-6)";
export const spacing8 = "var(--spacing-8)";
export const spacing10 = "var(--spacing-10)";
export const spacing12 = "var(--spacing-12)";
export const spacing16 = "var(--spacing-16)";
export const spacing20 = "var(--spacing-20)";
export const spacing24 = "var(--spacing-24)";
export const spacing05 = "var(--spacing-0-5)";
export const radiusNone = "var(--radius-none)";
export const radiusSm = "var(--radius-sm)";
export const radiusMd = "var(--radius-md)";
export const radiusLg = "var(--radius-lg)";
export const radiusFull = "var(--radius-full)";
export const motionDurationFast = "var(--motion-duration-fast)";
export const motionDurationBase = "var(--motion-duration-base)";
export const motionDurationSlow = "var(--motion-duration-slow)";
export const motionEasingStandard = "var(--motion-easing-standard)";
export const tokens = {
    color: {
        accent: colorAccent,
        "accent-hi": colorAccentHi,
        "accent-on-dark": colorAccentOnDark,
        "accent-on-dark-hi": colorAccentOnDarkHi,
        success: colorSuccess,
        warning: colorWarning,
        danger: colorDanger,
        "brand-on-dark": colorBrandOnDark,
        "brand-on-light": colorBrandOnLight,
        "brand-bg-dark": colorBrandBgDark,
        "brand-bg-light": colorBrandBgLight,
        "chart-s1": colorChartS1,
        "chart-s2": colorChartS2,
        "chart-s3": colorChartS3,
        "chart-s4": colorChartS4,
        "chart-s5": colorChartS5,
        "chart-s6": colorChartS6,
        "chart-s7": colorChartS7,
        "chart-s8": colorChartS8,
        "chart-ramp-1": colorChartRamp1,
        "chart-ramp-2": colorChartRamp2,
        "chart-ramp-3": colorChartRamp3,
        "chart-ramp-4": colorChartRamp4,
        "chart-ramp-5": colorChartRamp5,
        bg: colorBg,
        surface: colorSurface,
        elevated: colorElevated,
        border: colorBorder,
        "sidebar-bg": colorSidebarBg,
        "text-hi": colorTextHi,
        "text-md": colorTextMd,
        "text-lo": colorTextLo,
    },
    "font-family": {
        display: fontFamilyDisplay,
        body: fontFamilyBody,
        mono: fontFamilyMono,
    },
    "font-weight": {
        light: fontWeightLight,
        regular: fontWeightRegular,
        medium: fontWeightMedium,
        semibold: fontWeightSemibold,
    },
    "font-size": {
        display: fontSizeDisplay,
        title: fontSizeTitle,
        heading: fontSizeHeading,
        body: fontSizeBody,
        label: fontSizeLabel,
        data: fontSizeData,
    },
    "line-height": {
        display: lineHeightDisplay,
        title: lineHeightTitle,
        heading: lineHeightHeading,
        body: lineHeightBody,
        label: lineHeightLabel,
        data: lineHeightData,
    },
    "letter-spacing": {
        display: letterSpacingDisplay,
        label: letterSpacingLabel,
        wordmark: letterSpacingWordmark,
    },
    spacing: {
        "1": spacing1,
        "2": spacing2,
        "3": spacing3,
        "4": spacing4,
        "5": spacing5,
        "6": spacing6,
        "8": spacing8,
        "10": spacing10,
        "12": spacing12,
        "16": spacing16,
        "20": spacing20,
        "24": spacing24,
        "0-5": spacing05,
    },
    radius: {
        none: radiusNone,
        sm: radiusSm,
        md: radiusMd,
        lg: radiusLg,
        full: radiusFull,
    },
    motion: {
        duration: {
            fast: motionDurationFast,
            base: motionDurationBase,
            slow: motionDurationSlow,
        },
        easing: {
            standard: motionEasingStandard,
        },
    },
};
